export const styleLooks = [
  {
    id: 'look-1',
    category: '職場穿搭',
    title: '俐落知性・職場女王',
    desc: '合身剪裁西裝外套搭配高腰寬管褲，以奶油白為主軸，添加一條細金鍊點綴，塑造不失溫柔的職場強勢感。',
    items: ['奶油白修身西裝外套', '高腰寬管休閒褲', '米白尖頭踝靴', '金色細鍊包'],
    image: 'https://readdy.ai/api/search-image?query=elegant%20professional%20woman%20in%20cream%20white%20blazer%20and%20wide%20leg%20trousers%20standing%20in%20a%20modern%20minimalist%20office%20lobby%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20background%2C%20fashion%20editorial%20style%2C%20full%20body%20shot&width=480&height=640&seq=look1&orientation=portrait',
    tag: 'OFFICE LOOK',
    color: '#C49A3E',
  },
  {
    id: 'look-2',
    category: '週末休閒',
    title: '悠閒週末・輕鬆自在',
    desc: '棉麻質感oversized上衣搭配九分牛仔褲，配上白色厚底布鞋，週末逛街的完美減壓穿搭，舒適但不隨便。',
    items: ['棉麻Oversized上衣', '九分直筒牛仔褲', '白色厚底帆布鞋', '草編托特包'],
    image: 'https://readdy.ai/api/search-image?query=stylish%20casual%20woman%20in%20oversized%20linen%20top%20and%20cropped%20jeans%20walking%20in%20a%20sunny%20outdoor%20market%2C%20warm%20afternoon%20light%2C%20minimalist%20aesthetic%2C%20street%20fashion%20editorial%2C%20full%20body&width=480&height=640&seq=look2&orientation=portrait',
    tag: 'WEEKEND LOOK',
    color: '#A67C2E',
  },
  {
    id: 'look-3',
    category: '優雅洋裝',
    title: '綻放優雅・連身魅力',
    desc: '絲緞感V領洋裝以流暢線條修飾身形，搭配裸色高跟鞋與珍珠耳環，從午餐約會到晚宴場合皆宜。',
    items: ['絲緞感V領中長洋裝', '裸色尖頭高跟鞋', '珍珠耳環', '迷你鍊條手拿包'],
    image: 'https://readdy.ai/api/search-image?query=elegant%20woman%20in%20silky%20satin%20v-neck%20midi%20dress%20in%20warm%20cream%20beige%20tone%2C%20standing%20gracefully%20in%20luxury%20interior%20with%20golden%20hour%20light%2C%20full%20body%20fashion%20editorial%2C%20sophisticated%20and%20refined&width=480&height=640&seq=look3&orientation=portrait',
    tag: 'ELEGANT LOOK',
    color: '#C49A3E',
  },
  {
    id: 'look-4',
    category: '初秋層次',
    title: '秋日層次・溫暖氛圍',
    desc: '針織開衫疊穿薄款洋裝，搭配焦糖色樂福鞋，展現秋日層次感，暖色調配色讓整體散發溫柔氣息。',
    items: ['奶茶色針織開衫', '米白細肩吊帶裙', '焦糖色厚底樂福鞋', '棕色水桶包'],
    image: 'https://readdy.ai/api/search-image?query=fashionable%20woman%20layering%20a%20cozy%20knit%20cardigan%20over%20a%20slip%20dress%20in%20autumn%20neutral%20tones%2C%20warm%20golden%20light%2C%20outdoors%20with%20fallen%20leaves%2C%20elegant%20minimalist%20style%2C%20full%20body%20portrait&width=480&height=640&seq=look4&orientation=portrait',
    tag: 'AUTUMN LOOK',
    color: '#A67C2E',
  },
];

export const styleCategories = [
  { id: 'all', label: '全部' },
  { id: '職場穿搭', label: '職場穿搭' },
  { id: '週末休閒', label: '週末休閒' },
  { id: '優雅洋裝', label: '優雅洋裝' },
  { id: '初秋層次', label: '初秋層次' },
];

export const styleTips = [
  {
    id: 'tip-1',
    icon: 'ri-palette-line',
    title: '掌握中性色系',
    desc: '奶油白、裸米、焦糖棕是百搭神色，以這些為基底，加一個亮點色點綴，輕鬆創造高質感配色。',
  },
  {
    id: 'tip-2',
    icon: 'ri-scissors-2-line',
    title: '剪裁決定氣場',
    desc: '版型合身比追逐流行更重要。挑選符合自身體型的剪裁，即使是基本款也能穿出時尚感。',
  },
  {
    id: 'tip-3',
    icon: 'ri-sparkling-line',
    title: '配件畫龍點睛',
    desc: '一條細金鍊、一只簡約皮革包，就能將平凡的日常穿搭提升至輕奢質感，配件是最省力的升級方式。',
  },
  {
    id: 'tip-4',
    icon: 'ri-stack-line',
    title: '層次豐富造型',
    desc: '善用疊穿技巧：開衫+洋裝、西裝外套+連帽衫，層次感讓整體造型更有深度，也更能因應氣溫變化。',
  },
];
